import React from 'react';
import ActionsBarBase from '@/components/ActionsBar';
import type { ActionsBarProps } from '@/components/ActionsBar';

const ActionsBar = React.memo<ActionsBarProps>((props) => {
  return <ActionsBarBase {...props} />;
});

ActionsBar.displayName = 'ActionsBar';

export default ActionsBar;
